import React from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import Dashboard from './dashboard';
import Login from './Login';
import ResetPassword from './ResetPassword';

function AppGate() {
  const {
    isAuthenticated,
    loading,
    currentUser,
    passwordRecovery,
    needsPasswordSetup,
  } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <p className="text-sm font-bold text-purple-700">Loading Tikix PMS…</p>
      </div>
    );
  }

  // Invite acceptance and password-reset links must set a password before
  // the full app is available.
  if (needsPasswordSetup || passwordRecovery) {
    return (
      <ResetPassword mode={passwordRecovery ? 'recovery' : 'setup'} />
    );
  }

  if (!isAuthenticated || !currentUser) {
    return <Login />;
  }

  return <Dashboard />;
}

function App() {
  return (
    <AuthProvider>
      <AppGate />
    </AuthProvider>
  );
}

export default App;
